import React from "react";
import s from "./MessagingMeta.module.scss";
import { Skeleton } from "antd";
type PropType = {
  totalCreditsUsed: number;
  totalAmountUsd: number;
  avgDailyAmount: number;
  loading: boolean;
};
function FinancialMeta({
  avgDailyAmount,
  totalAmountUsd,
  totalCreditsUsed,
  loading,
}: PropType) {
  if (loading) {
    return (
      <div className={s.wrapper}>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Total credit used</h5>
        <p className={s.statNumber}>
          {totalCreditsUsed.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Total spends</h5>
        <p className={s.statNumber}>
          {totalAmountUsd.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Average spends</h5>
        <p className={s.statNumber}>
          {avgDailyAmount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      </div>
    </div>
  );
}

export default FinancialMeta;
